import {Component, OnInit} from '@angular/core';
import {ToastrService} from 'ngx-toastr';
import {LoaderService, OrderService} from '@app/shared/services';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {UtilsInjectable} from '@app/shared';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {FormsModule} from '@angular/forms';
import {PageHeaderComponent} from '@app/components/page-header/page-header.component';
import {RouterLink} from '@angular/router';
import {NgxPrintDirective} from 'ngx-print';

@Component({
  selector: 'app-price-list',
  templateUrl: './price-list.component.html',
  styleUrls: ['./price-list.component.scss'],
  imports: [
    CommonModule,
    FormsModule,
    PageHeaderComponent,
    RouterLink,
    NgxPrintDirective,
    NgOptimizedImage
  ]
})
export class PriceListComponent implements OnInit {

  public user_rights: any;
  public user_data: any = {};
  public now = new Date();

  public combo: any =
    {
      search_combo: '',

    }
  start = 0;
  limit = 10;
  p = 50;
  public collection: any = '';
  page = 1;
  status: any;
  index: any;
  router: any;
  closeResult = "";
  public combo_list: any = [];
  total = 0;
  price_total = 0;

  list: any;
  public institution = JSON.parse(localStorage.getItem('institution') || "{}");
  public logo_path = JSON.parse(localStorage.getItem('logo_path') || "{}");
  gross = 0;
  numberToWords: any;
  combo_datas: any;
  customer: any;
  date: any;
  print_data: any;

  constructor(private loaderService: LoaderService,
              private modalService: NgbModal,
              public orderService: OrderService,
              private toastr: ToastrService,
              public utils: UtilsInjectable,
  ) {

  }


  ngOnInit() {
    this.user_rights = JSON.parse(localStorage.getItem('user_rights') || "{}");
    this.user_data = JSON.parse(localStorage.getItem('user') || "{}");
    this.listPrice();
  }

  public print(data: any) {
    this.customer = ""
    this.date = ""
    this.print_data = []
    this.customer = data.CUSTOMER_ID
    this.date = this.utils.date(data.DATE)
    this.print_data = data.ITEMS
  }


  public getComboList(page = 0) {
    const limit = 50;
    this.start = page * limit;
    this.limit = limit;
    const postData = {
      start: this.start,
      limit: this.limit,
      combo_id: '0'
    };
    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.listPrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.combo_datas = result['data'];
        this.collection = result['total_count'];
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.collection = 0;
        this.combo_datas = []
      }
    });
  }

  public listPrice() {
    const postData = {
      start: this.start,
      limit: this.limit,
      search_text: this.combo.search_combo,
      combo_id: '0'
    };

    this.loaderService.display(true);
    window.scrollTo(0, 0);
    this.loaderService.display(true);
    this.orderService.listPrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.combo_datas = result['data'];
        this.combo_list = result['data'].COMBO;

        this.loaderService.display(false);
      } else {
        this.combo_datas = []
        this.loaderService.display(false);
      }
    });
  }

  public delete(data: any) {
    if (confirm("Are you sure to delete?")) {
      this.deletePrice(data);
    }
  }

  public deletePrice(data: any) {
    const postData = {
      customer_id: data.CUSTOMER_ID,
      user_id: this.user_data.user_id
    };
    this.loaderService.display(true);
    this.orderService.deletePrice(postData).subscribe((result: any) => {
      if (result['status'] == 'Success') {
        this.toastr.success(result["msg"])
        this.getComboList();
        this.loaderService.display(false);
      } else {
        this.loaderService.display(false);
        this.toastr.error(result["msg"])
      }
    });
  }

  protected open(content: any) {
    this.modalService.open(content, {
      ariaLabelledBy: 'modal-basic-title',
      size: 'a4-page',
      windowClass: "col-md-12"
    }).result.then((result: any) => {
      this.closeResult = `Closed with: ${result}`;
    }, (reason) => {
      this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
    });
  }

  private getDismissReason(reason: any): string {
    if (reason == ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason == ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }
}
